import Picture from '../picture'

interface Props {
  image: string
  imageAlt: string
  description: string
  title: string
  titleStyle?: string
  descriptionStyle?: string
  imageContainerStyle?: string
  imageStyle?: string
}

const FeatureItem = ({
  image,
  imageAlt,
  title,
  description,
  titleStyle,
  descriptionStyle,
  imageContainerStyle,
  imageStyle,
}: Props) => (
  <article className="flex md:flex-row flex-col pt-2.5">
    <div className={imageContainerStyle}>
      <Picture image={image} imageAlt={imageAlt} imageStyle={imageStyle} />
    </div>
    <div className="pt-4 md:px-4 flex-1">
      <h3 className={titleStyle}>{title}</h3>
      <p className={descriptionStyle}>{description}</p>
    </div>
  </article>
)

export default FeatureItem
